export const ACCESS_TOKEN_COOKIE_KEY = "MON_TOKEN_ACCESS";
export const ACCESS_TOKEN_EXPIRATION_COOKIE_KEY = "MON_TOKEN_EXPIRATION";
export const REFRESH_TOKEN_COOKIE_KEY = "MON_TOKEN_REFRESH";
export const GENERAL_MONTANA_COOKIE_KEY = "MON_TOKEN";
export const MONTANA_CART = "MON_CART";
export const MONTANA_MARKET_ID = "MON_MARKET_ID";
